import React, { useState } from 'react';
import axiosInstance from "../../../../axiosInstance";
import { API_URL } from "../../../../config";
import { Helmet } from 'react-helmet-async';
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';

const CanChangePasswordPage = () => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    });

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    // State to track visibility of each password field
    const [showPasswords, setShowPasswords] = useState({
        oldPassword: false,
        newPassword: false,
        confirmPassword: false
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    // Toggle password visibility for a specific field
    const togglePasswordVisibility = (field) => {
        setShowPasswords((prev) => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axiosInstance.post(`${API_URL}/change-password`, formData);
            toast.success(response.data.message || t("Password updated successfully"));
        } catch (error) {
            toast.error(error.response?.data.message || t("Error updating password"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Helmet>
                <title>Change password | CV Diffusion</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>
            <div className="twm-right-section-panel site-bg-gray">
                <form onSubmit={handleSubmit}>
                    <div className="panel panel-default">
                        <div className="panel-heading wt-panel-heading p-a20">
                            <h4 className="panel-tittle m-a0">{t("Change Password")}</h4>
                        </div>
                        <div className="panel-body wt-panel-body p-a20">
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>{t("Old Password")}</label>
                                        <div className="ls-inputicon-box">
                                            <input
                                                className="form-control wt-form-control"
                                                name="oldPassword"
                                                type={showPasswords.oldPassword ? 'text' : 'password'}
                                                placeholder="Enter old password"
                                                value={formData.oldPassword}
                                                onChange={handleChange} />
                                            <i
                                                className={`fs-input-icon fa ${showPasswords.oldPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                                                onClick={() => togglePasswordVisibility('oldPassword')}
                                                style={{ cursor: 'pointer' }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>{t("New Password")}</label>
                                        <div className="ls-inputicon-box">
                                            <input
                                                className="form-control wt-form-control"
                                                name="newPassword"
                                                type={showPasswords.newPassword ? 'text' : 'password'}
                                                placeholder="Enter new password"
                                                value={formData.newPassword}
                                                onChange={handleChange} />
                                            <i
                                                className={`fs-input-icon fa ${showPasswords.newPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                                                onClick={() => togglePasswordVisibility('newPassword')}
                                                style={{ cursor: 'pointer' }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>{t("Confirm New Password")}</label>
                                        <div className="ls-inputicon-box">
                                            <input
                                                className="form-control wt-form-control"
                                                name="confirmPassword"
                                                type={showPasswords.confirmPassword ? 'text' : 'password'}
                                                placeholder="Confirm new password"
                                                value={formData.confirmPassword}
                                                onChange={handleChange} />
                                            <i
                                                className={`fs-input-icon fa ${showPasswords.confirmPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                                                onClick={() => togglePasswordVisibility('confirmPassword')}
                                                style={{ cursor: 'pointer' }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-12 col-lg-12 col-md-12">
                                    <div className="text-left">
                                        <button type="submit" className="site-button" disabled={loading}>
                                            {loading ? `${t("Saving")}...` : `${t("Save Changes")}`}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default CanChangePasswordPage;


// import React, { useState } from 'react';
// import axiosInstance from "../../../../axiosInstance";
// import { API_URL } from "../../../../config";

// const CanChangePasswordPage = () => {
//     const [formData, setFormData] = useState({
//         oldPassword: '',
//         newPassword: '',
//         confirmPassword: ''
//     });

//     const [loading, setLoading] = useState(false);
//     const [message, setMessage] = useState('');
//     const [showPasswords, setShowPasswords] = useState({
//         oldPassword: false,
//         newPassword: false,
//         confirmPassword: false
//     });

//     const handleChange = (e) => {
//         setFormData({
//             ...formData,
//             [e.target.name]: e.target.value,
//         });
//     };

//     const togglePasswordVisibility = (field) => {
//         setShowPasswords((prev) => ({
//             ...prev,
//             [field]: !prev[field]
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         setMessage('');
//         try {
//             const response = await axiosInstance.post(`${API_URL}/change-password`, formData);
//             setMessage(response.data.message);
//             // Clear form inputs on successful password change
//             if (response.data.message.includes('success')) {
//                 setFormData({
//                     oldPassword: '',
//                     newPassword: '',
//                     confirmPassword: ''
//                 });
//                 // Optionally reset password visibility
//                 setShowPasswords({
//                     oldPassword: false,
//                     newPassword: false,
//                     confirmPassword: false
//                 });
//             }
//         } catch (error) {
//             setMessage(error.response?.data.message || 'Error updating password.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="twm-right-section-panel site-bg-gray">
//             <form onSubmit={handleSubmit}>
//                 <div className="panel panel-default">
//                     <div className="panel-heading wt-panel-heading p-a20">
//                         <h4 className="panel-tittle m-a0">Change Password</h4>
//                     </div>
//                     <div className="panel-body wt-panel-body p-a20">
//                         <div className="row">
//                             <div className="col-lg-6 col-md-6">
//                                 <div className="form-group">
//                                     <label>Old Password</label>
//                                     <div className="ls-inputicon-box">
//                                         <input
//                                             className="form-control wt-form-control"
//                                             name="oldPassword"
//                                             type={showPasswords.oldPassword ? 'text' : 'password'}
//                                             placeholder="Enter old password"
//                                             value={formData.oldPassword}
//                                             onChange={handleChange}
//                                         />
//                                         <i
//                                             className={`fs-input-icon fa ${showPasswords.oldPassword ? 'fa-eye' : 'fa-eye-slash'}`}
//                                             onClick={() => togglePasswordVisibility('oldPassword')}
//                                             style={{ cursor: 'pointer' }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-md-6">
//                                 <div className="form-group">
//                                     <label>New Password</label>
//                                     <div className="ls-inputicon-box">
//                                         <input
//                                             className="form-control wt-form-control"
//                                             name="newPassword"
//                                             type={showPasswords.newPassword ? 'text' : 'password'}
//                                             placeholder="Enter new password"
//                                             value={formData.newPassword}
//                                             onChange={handleChange}
//                                         />
//                                         <i
//                                             className={`fs-input-icon fa ${showPasswords.newPassword ? 'fa-eye' : 'fa-eye-slash'}`}
//                                             onClick={() => togglePasswordVisibility('newPassword')}
//                                             style={{ cursor: 'pointer' }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-md-6">
//                                 <div className="form-group">
//                                     <label>Confirm New Password</label>
//                                     <div className="ls-inputicon-box">
//                                         <input
//                                             className="form-control wt-form-control"
//                                             name="confirmPassword"
//                                             type={showPasswords.confirmPassword ? 'text' : 'password'}
//                                             placeholder="Confirm new password"
//                                             value={formData.confirmPassword}
//                                             onChange={handleChange}
//                                         />
//                                         <i
//                                             className={`fs-input-icon fa ${showPasswords.confirmPassword ? 'fa-eye' : 'fa-eye-slash'}`}
//                                             onClick={() => togglePasswordVisibility('confirmPassword')}
//                                             style={{ cursor: 'pointer' }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-xl-12 col-lg-12 col-md-12">
//                                 <div className="text-left">
//                                     <button type="submit" className="site-button" disabled={loading}>
//                                         {loading ? 'Saving...' : 'Save Changes'}
//                                     </button>
//                                 </div>
//                             </div>
//                             {message && (
//                                 <div className="col-xl-12 col-lg-12 col-md-12">
//                                     <div className={`alert ${message.includes('success') ? 'alert-success' : 'alert-danger'}`}>
//                                         {message}
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </form>
//         </div>
//     );
// };

// export default CanChangePasswordPage;